
import Vue from 'vue'

const locales = {keys(){return []}}
global['____A3C3799____'] = true;
delete global['____A3C3799____'];
global.__uniConfig = {"globalStyle":{"navigationBarTextStyle":"white","navigationBarTitleText":"CE","navigationBarBackgroundColor":"#4D525E","backgroundColor":"#F8F8F8","onReachBottomDistance":50},"easycom":{"autoscan":true,"custom":{"^nx-(.*)":"/src/components/nx-$1/nx-$1.vue","^uv-(.*)":"@climblee/uv-ui/components/uv-$1/uv-$1.vue","^uni-(.*)":"@dcloudio/uni-ui/lib/uni-$1/uni-$1.vue","^unicloud-db$":"@dcloudio/uni-cli-shared/components/unicloud-db.vue","^uniad$":"@dcloudio/uni-cli-shared/components/uniad.vue","^ad-rewarded-video$":"@dcloudio/uni-cli-shared/components/ad-rewarded-video.vue","^ad-fullscreen-video$":"@dcloudio/uni-cli-shared/components/ad-fullscreen-video.vue","^ad-interstitial$":"@dcloudio/uni-cli-shared/components/ad-interstitial.vue","^ad-interactive$":"@dcloudio/uni-cli-shared/components/ad-interactive.vue","^page-meta$":"@dcloudio/uni-cli-shared/components/page-meta.vue","^navigation-bar$":"@dcloudio/uni-cli-shared/components/navigation-bar.vue","^uni-match-media$":"@dcloudio/uni-cli-shared/components/uni-match-media.vue"}},"tabBar":{"borderStyle":"white","backgroundColor":"#ffffff","color":"#575859","selectedColor":"#347AFF","list":[{"pagePath":"pages/tabbar/home/home","text":"","iconPath":"","selectedIconPath":"","redDot":false,"badge":""},{"pagePath":"pages/tabbar/class/class","text":"","iconPath":"","selectedIconPath":"","redDot":false,"badge":""},{"pagePath":"pages/tabbar/mine/mine","text":"","iconPath":"","selectedIconPath":"","redDot":false,"badge":""}]},"h5":{"router":{"mode":"history"}}};
global.__uniConfig.compilerVersion = '4.45';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__A3C3799';
global.__uniConfig.appName = 'h5_preschool_zone';
global.__uniConfig.appVersion = '1.0.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"history","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":20000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {"maps":{"qqmap":{"key":"TKUBZ-D24AF-GJ4JY-JDVM2-IBYKK-KEBCU"}}};
global.__uniConfig.qqMapKey = "TKUBZ-D24AF-GJ4JY-JDVM2-IBYKK-KEBCU";
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-tabbar-home-home', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/tabbar/home/home"+'.vue')), 'pages-tabbar-home-home'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-tabbar-mine-mine', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/tabbar/mine/mine"+'.vue')), 'pages-tabbar-mine-mine'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-tabbar-class-class', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/tabbar/class/class"+'.vue')), 'pages-tabbar-class-class'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-home-post-post', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/home/post/post"+'.vue')), 'pages-home-post-post'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-home-album-album', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/home/album/album"+'.vue')), 'pages-home-album-album'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-home-album-albumStyle', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/home/album/albumStyle"+'.vue')), 'pages-home-album-albumStyle'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-home-postDetail-postDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/home/postDetail/postDetail"+'.vue')), 'pages-home-postDetail-postDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-class-post-post', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/class/post/post"+'.vue')), 'pages-class-post-post'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-class-postList-postList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/class/postList/postList"+'.vue')), 'pages-class-postList-postList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-class-SaveToGallery-SaveToGallery', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/class/SaveToGallery/SaveToGallery"+'.vue')), 'pages-class-SaveToGallery-SaveToGallery'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-class-postDetail-postDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/class/postDetail/postDetail"+'.vue')), 'pages-class-postDetail-postDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine-role-role', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/mine/role/role"+'.vue')), 'pages-mine-role-role'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine-gallery-gallery', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/mine/gallery/gallery"+'.vue')), 'pages-mine-gallery-gallery'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine-userInfo-userInfo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/mine/userInfo/userInfo"+'.vue')), 'pages-mine-userInfo-userInfo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine-setting-setting', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/mine/setting/setting"+'.vue')), 'pages-mine-setting-setting'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine-preview-preview', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/mine/preview/preview"+'.vue')), 'pages-mine-preview-preview'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine-selChild-selChild', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/mine/selChild/selChild"+'.vue')), 'pages-mine-selChild-selChild'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine-message-message', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/mine/message/message"+'.vue')), 'pages-mine-message-message'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine-message-messageDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/mine/message/messageDetail"+'.vue')), 'pages-mine-message-messageDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine-childInfo-childInfo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/mine/childInfo/childInfo"+'.vue')), 'pages-mine-childInfo-childInfo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-login', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/login/login"+'.vue')), 'pages-login-login'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-websiteAgreement', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/login/websiteAgreement"+'.vue')), 'pages-login-websiteAgreement'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-forgotPassword', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/data/www/ce_preschool/src/pages/login/forgotPassword"+'.vue')), 'pages-login-forgotPassword'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/tabbar/home/home',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,
isTabBar:true,

          
          tabBarIndex:0
        },__uniConfig.globalStyle,{"enablePullDownRefresh":false,"navigationStyle":"custom"})
      },
      [
        createElement('pages-tabbar-home-home', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-tabbar-home-home',
  isNVue:false,maxWidth:0,
  pagePath:'pages/tabbar/home/home',
isQuit:true,
isEntry:true,
isTabBar:true,
tabBarIndex:0,
  windowTop:0
}
},
{
path: '/pages/tabbar/mine/mine',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:2
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationStyle":"custom"})
      },
      [
        createElement('pages-tabbar-mine-mine', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:2,
  name:'pages-tabbar-mine-mine',
  isNVue:false,maxWidth:0,
  pagePath:'pages/tabbar/mine/mine',
isQuit:true,
isTabBar:true,
tabBarIndex:2,
  windowTop:0
}
},
{
path: '/pages/tabbar/class/class',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:1
        },__uniConfig.globalStyle,{"enablePullDownRefresh":false,"navigationStyle":"custom"})
      },
      [
        createElement('pages-tabbar-class-class', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:3,
  name:'pages-tabbar-class-class',
  isNVue:false,maxWidth:0,
  pagePath:'pages/tabbar/class/class',
isQuit:true,
isTabBar:true,
tabBarIndex:1,
  windowTop:0
}
},
{
path: '/pages/home/post/post',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":""})
      },
      [
        createElement('pages-home-post-post', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-home-post-post',
  isNVue:false,maxWidth:0,
  pagePath:'pages/home/post/post',
  windowTop:0
}
},
{
path: '/pages/home/album/album',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationStyle":"custom"})
      },
      [
        createElement('pages-home-album-album', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-home-album-album',
  isNVue:false,maxWidth:0,
  pagePath:'pages/home/album/album',
  windowTop:0
}
},
{
path: '/pages/home/album/albumStyle',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":true})
      },
      [
        createElement('pages-home-album-albumStyle', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-home-album-albumStyle',
  isNVue:false,maxWidth:0,
  pagePath:'pages/home/album/albumStyle',
  windowTop:44
}
},
{
path: '/pages/home/postDetail/postDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-home-postDetail-postDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-home-postDetail-postDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/home/postDetail/postDetail',
  windowTop:44
}
},
{
path: '/pages/class/post/post',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":""})
      },
      [
        createElement('pages-class-post-post', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-class-post-post',
  isNVue:false,maxWidth:0,
  pagePath:'pages/class/post/post',
  windowTop:0
}
},
{
path: '/pages/class/postList/postList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-class-postList-postList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-class-postList-postList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/class/postList/postList',
  windowTop:44
}
},
{
path: '/pages/class/SaveToGallery/SaveToGallery',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-class-SaveToGallery-SaveToGallery', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-class-SaveToGallery-SaveToGallery',
  isNVue:false,maxWidth:0,
  pagePath:'pages/class/SaveToGallery/SaveToGallery',
  windowTop:44
}
},
{
path: '/pages/class/postDetail/postDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-class-postDetail-postDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-class-postDetail-postDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/class/postDetail/postDetail',
  windowTop:44
}
},
{
path: '/pages/mine/role/role',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true})
      },
      [
        createElement('pages-mine-role-role', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mine-role-role',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mine/role/role',
  windowTop:44
}
},
{
path: '/pages/mine/gallery/gallery',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationStyle":"custom","navigationBarTitleText":""})
      },
      [
        createElement('pages-mine-gallery-gallery', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mine-gallery-gallery',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mine/gallery/gallery',
  windowTop:0
}
},
{
path: '/pages/mine/userInfo/userInfo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true})
      },
      [
        createElement('pages-mine-userInfo-userInfo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mine-userInfo-userInfo',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mine/userInfo/userInfo',
  windowTop:44
}
},
{
path: '/pages/mine/setting/setting',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true})
      },
      [
        createElement('pages-mine-setting-setting', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mine-setting-setting',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mine/setting/setting',
  windowTop:44
}
},
{
path: '/pages/mine/preview/preview',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom"})
      },
      [
        createElement('pages-mine-preview-preview', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mine-preview-preview',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mine/preview/preview',
  windowTop:0
}
},
{
path: '/pages/mine/selChild/selChild',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":""})
      },
      [
        createElement('pages-mine-selChild-selChild', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mine-selChild-selChild',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mine/selChild/selChild',
  windowTop:44
}
},
{
path: '/pages/mine/message/message',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"enablePullDownRefresh":true,"navigationBarTitleText":""})
      },
      [
        createElement('pages-mine-message-message', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mine-message-message',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mine/message/message',
  windowTop:44
}
},
{
path: '/pages/mine/message/messageDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-mine-message-messageDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mine-message-messageDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mine/message/messageDetail',
  windowTop:44
}
},
{
path: '/pages/mine/childInfo/childInfo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":""})
      },
      [
        createElement('pages-mine-childInfo-childInfo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mine-childInfo-childInfo',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mine/childInfo/childInfo',
  windowTop:0
}
},
{
path: '/pages/login/login',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom"})
      },
      [
        createElement('pages-login-login', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-login',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/login',
  windowTop:0
}
},
{
path: '/pages/login/websiteAgreement',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-login-websiteAgreement', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-websiteAgreement',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/websiteAgreement',
  windowTop:44
}
},
{
path: '/pages/login/forgotPassword',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom"})
      },
      [
        createElement('pages-login-forgotPassword', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-forgotPassword',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/forgotPassword',
  windowTop:0
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
